import React, { useState, useEffect } from "react";
import { Grid, Paper } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import SOHeaderView from "./SOHeaderView";
import SODtlsView from "./SODtlsView";
import SORelatedView from "./SORelatedView";
import UseFetchData from "../../../hooks/UseFetchData";

const SOMasterView = () => {
  debugger;
  const classes = useStyles();
  const [SOMainData, setSOMainData] = useState([]);
  const [SODtlsData, setSODtlsData] = useState([]);
  const [SONoteData, setSONoteData] = useState([]);
  const [SOAttachData, setSOAttachData] = useState([]);
  const [SOImageData, setSOImageData] = useState([]);
  // const [ProductCount,setProductCount] = useState(0);
  const [SOActivityData, setSOActivityData] = useState([]);
  const [AccountID, setAccountID] = useState('');
  const [AccountName, setAccountName] = useState('');
  const location = useLocation();
  const [responseViewDtls, fetchViewDtls] = UseFetchData();
  // const QID = location.state.QuotationID;


  const getViewDtlsData = () => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("SalesOrderID", location.state.SalesOrderID);
    // bodyFormData.append("QuotationID", QID);
    fetchViewDtls("SalesOrder/View", bodyFormData);
  }

  useEffect(() => {
    // debugger;
    if (responseViewDtls.Main !== undefined && responseViewDtls.Main.length > 0) {
      setSOMainData(responseViewDtls.Main);
      setAccountID(responseViewDtls.Main[0].AccountID);
      setAccountName(responseViewDtls.Main[0].AccountName);
    }
    if (responseViewDtls.SalesOrderDtls !== undefined && responseViewDtls.SalesOrderDtls.length > 0) {
      setSODtlsData(responseViewDtls.SalesOrderDtls);
      // setProductCount(responseViewDtls.SalesOrderDtls.length);
    }
    if (responseViewDtls.SalesOrderActivity !== undefined && responseViewDtls.SalesOrderActivity.length > 0) {
      setSOActivityData(responseViewDtls.SalesOrderActivity);
    }
    if (responseViewDtls.SalesOrderNotes !== undefined && responseViewDtls.SalesOrderNotes.length > 0) {
      setSONoteData(responseViewDtls.SalesOrderNotes);
    }
    if (responseViewDtls.SalesOrderAttachments !== undefined && responseViewDtls.SalesOrderAttachments.length > 0) {
      setSOAttachData(responseViewDtls.SalesOrderAttachments);
    }
    if (responseViewDtls.SalesOrderImage !== undefined && responseViewDtls.SalesOrderImage.length > 0) {
      setSOImageData(responseViewDtls.SalesOrderImage);
    }
  }, [responseViewDtls]);

  useEffect(() => {
    getViewDtlsData();

  }, [])

  return (
    <Paper>
      <SOHeaderView
        SalesOrderID={location.state.SalesOrderID}
        SOMainData={SOMainData}
        PopulateData={getViewDtlsData}
      // ProductCount={ProductCount}
      // setProductCount={setProductCount}
      />
      <Grid container direction="row" className={classes.container}>
        <Grid sm={8} xs={12}>
          <Paper elevation={3} style={{ height: '100%' }}>
            <SODtlsView
              SalesOrderID={location.state.SalesOrderID}
              SOMainData={SOMainData}
              SODtlsData={SODtlsData}
              PopulateData={getViewDtlsData}
            />
          </Paper>

        </Grid>

        <Grid sm={4} xs={12}>
          <Paper elevation={3} >
            <h2 style={{ textDecoration: 'underline', textDecorationColor: '#0096FF', textDecorationThickness: 5, paddingLeft: 10 }}>RELATED</h2>
            <SORelatedView
              SalesOrderID={location.state.SalesOrderID}
              SOMainData={SOMainData}
              SONoteData={SONoteData}
              SOAttachData={SOAttachData}
              SOImageData={SOImageData}
              SOActivityData={SOActivityData}
              ACID={AccountID}
              ACName={AccountName}
              PopulateData={getViewDtlsData}
            />
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 7,
  },
}));

export default SOMasterView;
